import React from "react";
import "./resultsModal.css"; // CSS we updated earlier

const ResultsModal = ({ examTitle, questions, answers, summary, score, onClose }) => {
  return (
    <div className="modal-overlay">
      <div className="modal-container">
        {/* Modal Header */}
        <div className="modal-header">
            <h2>{examTitle || "Exam Results"}</h2>
          <button className="close-button" onClick={onClose}>×</button>
        </div>

        {/* Summary Cards */}
        <div className="modal-body">
          <div className="summary-section-cards">
            <div className="summary-card total">
              <span className="icon">📝</span>
              <div className="text">
                <p>Total Questions</p>
                <h3>{questions.length}</h3>
              </div>
            </div>

            <div className="summary-card correct">
              <span className="icon">✅</span>
              <div className="text">
                <p>Correct</p>
                <h3>{summary.correct}</h3>
              </div>
            </div>

            <div className="summary-card incorrect">
              <span className="icon">❌</span>
              <div className="text">
                <p>Incorrect</p>
                <h3>{summary.incorrect}</h3>
              </div>
            </div>

            <div className="summary-card not-answered">
              <span className="icon">🕳</span>
              <div className="text">
                <p>Not Answered</p>
                <h3>{summary.notAnswered}</h3>
              </div>
            </div>

            <div className="summary-card final-score">
              <span className="icon">🏆</span>
              <div className="text">
                <p>Final Score</p>
                <h3>{score}/{questions.length}</h3>
              </div>
            </div>
          </div>
          <hr />

          {/* Per-Question Summary */}
          <h3>Per-Question Summary</h3>
          <div className="per-question-summary">
            {questions.map((q, idx) => {
              const userAnswer = (answers[q.id] || "Not Answered").toUpperCase();
              const correctAnswer = (q.correctAnswer || "Not Provided").toUpperCase();
              const status = userAnswer === correctAnswer
                ? "correct"
                : userAnswer === "NOT ANSWERED"
                  ? "not-answered"
                  : "incorrect";

              return (
                <div key={q.id} className={`question-result ${status}`}>
                  <p><strong>Q{idx + 1}:</strong> {q.questionText}</p>
                  <p><strong>Your Answer:</strong> {userAnswer}</p>
                  <p><strong>Correct Answer:</strong> {correctAnswer}</p>
                  <p><strong>Explanation:</strong> {q.explanation}</p>
                </div>
              );
            })}
          </div>
        </div>

        {/* Modal Footer */}
        <div className="modal-footer">
          <button className="primary-button" onClick={onClose}>Back to Dashboard</button>
        </div>
      </div>
    </div>
  );
};

export default ResultsModal;